export const isTextItemVisibleOnCanvas = (item) => item?.visibleOnCanvas !== false;
